import apiClient from '@/plugins/axios';

export default {
	list(params, opts = {}) {
		return apiClient.get('v1/Company', {params, ...opts});
	},

	getCompanies(params) {
		params.pageNumber = params.currentPage;

		return apiClient.get('v1/Company', { params });
	},

	getCompany(companyId) {
		return apiClient.get(`v1/Company/${companyId}`);
	},

	createCompany(company, opts = {}) {
		return apiClient.post('v1/Company', company, opts);
	},

	update(id, body, opts = {}) {
		return apiClient.put(`v1/Company/${id}`, body, opts);
	},

	updateCompany(company) {
		return apiClient.put(`v1/Company/${company.id}`, company);
	},

	deleteCompany(companyId) {
		return apiClient.delete(`v1/Company/${companyId}`);
	}
};
